import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { CheckApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { CheckApprovalVacation } from "@/models/approval/ApprovalResponse";
import CheckApprovalTableBase from "../CheckApprovalTableBase.vue";
import { DataTableHeader } from "vuetify";
import { $confirm } from "@/plugins/confirm/confirm";
import { Paths } from "@/plugins/api/paths";
import { $post } from "@/plugins/api/api";
import { $alert } from "@/plugins/alert/alert";
import { EnumApprovalState, EnumCheckApproval } from "@/models/enum/Enum";
import VacationExpandItem from "@/components/approval/expand/VacationExpandItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckVacationTable',
  setup(__props) {

const headers: DataTableHeader[] = [
  { text: "申請日", value: "requestDate", divider: true },
  { text: "対象日", value: "petitionDate", divider: true },
  { text: "社員コード", value: "employeeCode", divider: true },
  { text: "社員名", value: "employeeName", divider: true },
  { text: "所属名", value: "affiliationName", divider: true },
  {
    text: "承認状態",
    value: "approvalState",
    divider: true,
    sortable: false,
    align: "center",
    width: 85
  },
  {
    text: "確認状態",
    value: "checkApproval",
    divider: true,
    sortable: false,
    align: "center",
    width: 85
  }
];

const title = "休暇申請確認";
const items = ref<CheckApprovalVacation[]>([]);
const form = ref<CheckApprovalSearchRequest>({
  approvals: [EnumApprovalState.RESOLVE, EnumApprovalState.REJECT],
  checkApprovalManager: EnumCheckApproval.No
});

const getItems = async (request: CheckApprovalSearchRequest) => {
  const response = await $post<CheckApprovalVacation[]>(
    Paths.checkApproval.vacation.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onCheck = async (ids: number[]) => {
  const message = `${ids.length}件確認状態にします。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.checkApproval.vacation.check, { ids });
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,headers, title, items, form, getItems, onSearch, onCheck, CheckApprovalTableBase, VacationExpandItem }
}

})